// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"CardsSwiper_swiperContainer__2Qugt","card":"CardsSwiper_card__33N2b","active":"CardsSwiper_active__2YbZr"};